import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Typography from 'material-ui/Typography'
import Select from 'material-ui/Select'
import {MenuItem} from 'material-ui/Menu'
import {CircularProgress} from 'material-ui/Progress'

import {paymentMethod as text} from '../text'
import {paymentMethodStyles} from '../styles'
import {
  CardNumberInput,
  CardExpiryInput,
  CardCVCInput,
  CardholderNameInput,
} from '../../../common/components/CreditCardInput'
import LoadingButton from '../../../common/components/LoadingButton'
import Grid from '../../../common/components/Grid'

class PaymentMethod extends React.Component {

  state = {
    tab: 0,
    type: null,
  }

  componentWillReceiveProps(props) {
    if (props.isFormLoading === false && props.cards.length === 0) {
      this.setTab(1)
    }
  }

  handleNumberChange = (value, type) => {
    this.setState({type})
    this.props.setNumber(value)
  }

  handleExpiryChange = (month, year) => {
    this.props.setExpiry(month + ' / ' + year)
  }

  handleCVVChange = cvc => {
    this.props.setCVC(cvc)
  }

  handleNameChange = name => {
    this.props.setCardholderName(name)
  }

  setTab = tab => {
    this.props.setTab(tab)
  }

  render() {
    const {classes, tab, cards, selected, isFormLoading, isButtonLoading, isButtonDisabled} = this.props
    return (
      <div>
        <form>
          {tab === 0 ?
            <div>
              <Title classes={classes} text={text.selectOneOfYourCards}/>
              <Cards
                classes={classes}
                isLoading={isFormLoading}
                cards={cards}
                selected={selected}
                select={this.props.setSelected}
              />
              <Link classes={classes} text={text.orAddANewCard} onClick={() => this.setTab(1)}/>
            </div>
            : null
          }
          {
            tab === 1 ?
              <div>
                <Title classes={classes} text={text.addANewCard}/>
                <AddCard
                  classes={classes}
                  isLoading={isFormLoading}
                  handleNumberChange={this.handleNumberChange}
                  handleExpiryChange={this.handleExpiryChange}
                  handleCVVChange={this.handleCVVChange}
                  handleNameChange={this.handleNameChange}
                  type={this.state.type}
                />
                <Link classes={classes} text={text.orSelectOneOfYourCards} onClick={() => this.setTab(0)}/>
              </div>
              : null
          }
          <Actions
            classes={classes}
            isLoading={isButtonLoading}
            isDisabled={isButtonDisabled}
            onClick={
              tab === 0
                ? () => this.props.modifyTransaction()
                : () => this.props.save(this.state.type)}
          />
        </form>
      </div>
    )
  }

  static propTypes = {
    tab: PropTypes.number,
    setTab: PropTypes.func.isRequired,
    cards: PropTypes.array,
    selected: PropTypes.number,
    add: PropTypes.shape({
      number: PropTypes.string,
      expiry: PropTypes.string,
      cvc: PropTypes.string,
      cardholderName: PropTypes.string,
    }),
    save: PropTypes.func.isRequired,
    modifyTransaction: PropTypes.func.isRequired,
    setSelected: PropTypes.func.isRequired,
    setNumber: PropTypes.func.isRequired,
    setExpiry: PropTypes.func.isRequired,
    setCVC: PropTypes.func.isRequired,
    setCardholderName: PropTypes.func.isRequired,
    isFormLoading: PropTypes.bool,
    isButtonLoading: PropTypes.bool,
    isButtonDisabled: PropTypes.bool,
    error: PropTypes.string,
  }
}

const Title = ({classes, text}) => (
  <div>
    <Typography variant="title" className={classes.dialogTitle}>{text}</Typography>
  </div>
)

const Link = ({classes, text, onClick}) => (
  <div onClick={onClick}>
    <Typography className={classes.link}>{text}</Typography>
  </div>
)

const Cards = ({classes, isLoading, cards, selected, select}) => (
  <div style={{position: 'relative'}}>
    {isLoading === true ? <LoadingBackdrop classes={classes}/> : null}
    <Select
      value={selected}
      onChange={e => select(e.target.value)}
      fullWidth={true}
    >
      {cards.length === 0 ? <MenuItem key={0} value={0}>...</MenuItem> : null}
      {cards.map(c => (
        <MenuItem key={c.ID} value={c.ID}>{`···· ${c.LastDigits} (${c.Type})`}</MenuItem>
      ))}
    </Select>
  </div>
)

const AddCard = ({classes, isLoading, handleNumberChange, handleExpiryChange, handleCVVChange, handleNameChange, type}) => (
  <div style={{position: 'relative'}}>
    {isLoading === true ? <LoadingBackdrop classes={classes}/> : null}
    <Grid container>
      <Grid item xs={12} style={{paddingLeft: 0, paddingRight: 0}}>
        <CardNumberInput onChange={(v, e, t) => handleNumberChange(v, t)} autoFocus={true}/>
      </Grid>
      <Grid item xs={6} style={{padding: 0}}>
        <CardExpiryInput onChange={(m, y) => handleExpiryChange(m, y)} margin="dense"/>
      </Grid>
      <Grid item xs={6} style={{padding: 0}}>
        <CardCVCInput onChange={(v) => handleCVVChange(v)} margin="dense" type={type}/>
      </Grid>
      <Grid item xs={12} style={{padding: 0}}>
        <CardholderNameInput onChange={(v) => handleNameChange(v)} margin="dense"/>
      </Grid>
    </Grid>
  </div>
)

const Actions = ({classes, isLoading, isDisabled, onClick}) => (
  <div className={classes.dialogActions}>
    <LoadingButton
      variant="raised"
      color="primary"
      type="submit"
      onClick={onClick}
      disabled={isDisabled}
      isLoading={isLoading}
      className={classes.button}
    >
      Aceptar
    </LoadingButton>
  </div>
)

//TODO refactor into common component
const LoadingBackdrop = ({classes}) => {
  return (
    <div className={classes.loadingContainer}>
      <CircularProgress
        size={24}
        className={classes.progress}
      />
    </div>
  )
}

export default withStyles(paymentMethodStyles, {withTheme: true})(PaymentMethod)



// WEBPACK FOOTER //
// ./src/sections/deposit/components/paymentMethod.js